// extracted by mini-css-extract-plugin
export var calendarView = "_ml-0";